<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title>Pozisyon</b-card-title>
          <b-row>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Departman">
                <v-select
                  v-model="formData.id_departments"
                  :options="departmentsList"
                  label="title"
                  :reduce="departments => departments.id"
                  placeholder="Departman Seçiniz"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Görev">
                <v-select
                  v-model="formData.id_employee_tasks"
                  :options="employeeTasksList"
                  label="title"
                  :reduce="employee_tasks => employee_tasks.id"
                  placeholder="Görev Seçiniz"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Yönetici">
                <v-select
                  v-model="formData.id_manager_employees"
                  :options="employeeList"
                  label="employee"
                  :reduce="employees => employees.id"
                  placeholder="Yönetici Seçiniz"
                />
              </b-form-group>
            </b-col>
            <b-col
              xs="12"
              md="6"
            >
              <b-form-group label="Görev Başlangıç">
                <b-form-datepicker
                  id="position_started"
                  v-model="formData.started"
                  v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                  locale="tr"
                  start-weekday="1"
                  class="mb-1"
                  :max="today"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                variant="primary"
                class="mt-2"
                @click="submitForm"
              >
                Kaydet
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title>Maaş</b-card-title>
          <b-row>
            <b-col>
              <b-table
                responsive
                :items="employeeSalaries"
                :fields="fields"
                class="mb-0"
              >
                <template #cell(title)="data">
                  <span class="text-nowrap">
                    {{ data.value }}
                  </span>
                </template>
                <template #cell(delete)="data">
                  <span class="text-nowrap">
                    <b-button
                      variant="danger"
                      size="sm"
                      @click="deleteSalary(data.item.id)"
                    >
                      Sil
                    </b-button>
                  </span>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title>Maaş Ekle</b-card-title>
          <b-row>
            <b-col
              md="6"
              sm="12"
            >
              <b-form-group label="Ödeme">
                <b-form-input
                  placeholder="Ödeme"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              sm="12"
            >
              <b-form-group label="Ödeme Tipi">
                <v-select
                  :options="employeePaymentTypes"
                  label="title"
                  :reduce="employee_payment_types => employee_payment_types.id"
                  placeholder="Ödeme Tipi"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              sm="12"
            >
              <b-form-group label="Başlangıç Tarihi">
                <b-form-datepicker
                  v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                  locale="tr"
                  start-weekday="1"
                  class="mb-1"
                  :max="today"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              sm="12"
            >
              <b-form-group label="Maaş Dönemi">
                <v-select
                  :options="salaryPeriods"
                  label="title"
                  :reduce="salary_periods => salary_periods.id"
                  placeholder="Maaş Dönemi"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                variant="primary"
                class="mt-2"
              >
                Kaydet
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BRow, BCol, BCard, BCardTitle, BFormGroup, BFormDatepicker, BTable, BButton, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'Career',
  components: {
    BFormDatepicker,
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BFormGroup,
    BTable,
    BButton,
    BFormInput,
    vSelect,
  },
  data() {
    return {
      today: this.moment().format('YYYY-MM-DD'),
      fields: [
        {
          key: 'employee_salary', label: 'Maaş',
        },
        {
          key: 'title', label: 'Başlık',
        },
        {
          key: 'delete', label: 'Sİl',
        },
      ],
      formData: {
        id_departments: null,
        id_employee_tasks: null,
        id_manager_employees: null,
        started: null,
      },
    }
  },
  computed: {
    employeeTasksList() {
      return this.$store.getters['employeeTasks/getEmployeeTasks']
    },
    departmentsList() {
      return this.$store.getters['departments/getDepartments']
    },
    employee() {
      return this.$store.getters['employees/getEmployee']
    },
    employeeList() {
      return this.$store.getters['employees/getEmployees']
    },
    positions() {
      return this.$store.getters['employeePosition/getEmployeePositions']
    },
    employeeSalaries() {
      return this.$store.getters['employeeSalaryDetails/getEmployeeSalaryDetails']
    },
    employeePaymentTypes() {
      return this.$store.getters['employeePaymentTypes/getemployeePaymentTypes']
    },
    salaryPeriods() {
      return this.$store.getters['salaryPeriods/getSalaryPeriods']
    },
    saveStatus() {
      return this.$store.getters['employeePosition/getEmployeePositionSaveStatus']
    },
  },
  watch: {
    positions(val) {
      this.setFormData(val)
    },
    saveStatus(val) {
      if (val.status === true) {
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {
    this.getEmployee()
    this.getEmployeePosition()
    this.getDepartments()
    this.getEmployeeTasks()
    this.getEmployeeSalaryDetails()
    this.getEmployees()
    this.getEmployeePaymentTypes()
    this.getSalaryPeriods()
  },
  methods: {
    getEmployeeTasks() {
      this.$store.dispatch('employeeTasks/employeeTasksList')
    },
    getDepartments() {
      this.$store.dispatch('departments/departmentsList')
    },
    getEmployee() {
      this.$store.dispatch('employees/employeeView', this.$route.params.id)
    },
    getEmployees() {
      this.$store.dispatch('employees/employeesList')
    },
    getEmployeePosition() {
      this.$store.dispatch('employeePosition/employeePositionsList', {
        where: {
          'employee_position.id_employees': this.$route.params.id,
        },
        array: false,
      })
    },
    getEmployeeSalaryDetails() {
      this.$store.dispatch('employeeSalaryDetails/employeeSalaryDetailsList', {
        select: [
          'employee_salary.salary                             AS employee_salary',
          'employee_payments_types.title                      AS title',
          'concat(employees.name, " ", employees.surname)     AS employee',
        ],
        where: {
          'employee_salary.id_employees': this.$route.params.id,
        },
        order_by: ['employee_salary_details.id', 'DESC'],
      })
    },
    getEmployeePaymentTypes() {
      this.$store.dispatch('employeePaymentTypes/employeePaymentTypesList')
    },
    getSalaryPeriods() {
      this.$store.dispatch('salaryPeriods/salaryPeriodsList')
    },
    setFormData(data) {
      this.formData = data
    },
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    submitForm() {
      this.submitStatus = true
      this.$store.dispatch('employeePosition/employeePositionSave', this.formData)
    },
  },
}

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
